const User = {
    dbUser: null,
    awsUser: null
}

export default User;